import { inject } from '@angular/core';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { initSessionSuccess, updateIdentityCard, updateIdentityCardSuccess } from '@stores/session/session-ngrx.action';
import { userId } from '@wizbii-utils/angular/stores';
import { AccountWebservice, AuthenticationWebservice } from '@wizbii-utils/angular/webservices';
import { combineLatest, filter, map, switchMap } from 'rxjs';

export const initSession = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store),
    authWebservice = inject(AuthenticationWebservice),
    accountWebservice = inject(AccountWebservice)
  ) =>
    actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => store.select(userId)),
      filter((userId): userId is string => !!userId),
      switchMap((userId: string) =>
        combineLatest([authWebservice.getUserOverview(userId), accountWebservice.getIdentityCard(userId)])
      ),
      map(([userOverview, identityCard]) => initSessionSuccess({ userOverview, identityCard }))
    ),
  { functional: true }
);

export const updateIdentityCardEffect = createEffect(
  (actions$ = inject(Actions), accountWebservice = inject(AccountWebservice)) =>
    actions$.pipe(
      ofType(updateIdentityCard),
      switchMap((action) => accountWebservice.updateIdentityCard(action.identityCard).pipe(map(() => action))),
      map((action) => updateIdentityCardSuccess({ identityCard: action.identityCard }))
    ),
  { functional: true }
);
